// UrbnBeat — theme.js
(function () {
  // Search overlay
  const searchOverlay = document.querySelector('[data-search-overlay]');
  if (searchOverlay) {
    const openSearch = () => {
      searchOverlay.classList.add('is-open');
      searchOverlay.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      if (typeof lucide !== 'undefined') lucide.createIcons();
      setTimeout(() => searchOverlay.querySelector('[data-search-input]')?.focus(), 150);
    };
    const closeSearch = () => {
      searchOverlay.classList.remove('is-open');
      searchOverlay.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    };
    document.querySelectorAll('[data-search-toggle]').forEach(btn => btn.addEventListener('click', (e) => { e.preventDefault(); openSearch(); }));
    searchOverlay.querySelectorAll('[data-search-close]').forEach(btn => btn.addEventListener('click', closeSearch));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && searchOverlay.classList.contains('is-open')) closeSearch(); });
  }

  // Size guide dialog
  document.querySelectorAll('[data-size-chart]').forEach(dialog => {
    // start fetching the chart on the first sign of intent, so it is ready when the dialog opens
    const img = dialog.querySelector('img');
    const warm = () => { if (img && img.loading === 'lazy') img.loading = 'eager'; };
    document.querySelectorAll('[data-size-chart-open]').forEach(btn => {
      ['pointerenter', 'touchstart', 'focus'].forEach(evt => btn.addEventListener(evt, warm, { once: true, passive: true }));
      btn.addEventListener('click', () => { warm(); dialog.showModal(); });
    });
    dialog.querySelectorAll('[data-size-chart-close]').forEach(btn => btn.addEventListener('click', () => dialog.close()));
    // a click on the dialog element itself is a click on the backdrop
    dialog.addEventListener('click', (e) => { if (e.target === dialog) dialog.close(); });
  });

  // Hero slider
  document.querySelectorAll('[data-hero]').forEach(hero => {
    const slides = hero.querySelectorAll('[data-hero-slide]');
    const dots = hero.querySelectorAll('[data-hero-dot]');
    if (slides.length < 2) return;
    let i = 0;
    const show = (idx) => {
      slides.forEach((s, n) => s.style.display = n === idx ? '' : 'none');
      dots.forEach((d, n) => d.classList.toggle('is-active', n === idx));
      i = idx;
    };
    dots.forEach((d, n) => d.addEventListener('click', () => show(n)));
    show(0);
    setInterval(() => show((i + 1) % slides.length), 6000);
  });

  // Cart drawer
  const cartDrawer = document.querySelector('[data-cart-drawer]');
  if (cartDrawer) {
    document.querySelectorAll('[data-cart-toggle]').forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        cartDrawer.classList.add('is-open');
        document.body.style.overflow = 'hidden';
        if (typeof lucide !== 'undefined') lucide.createIcons();
      });
    });
    cartDrawer.querySelectorAll('[data-cart-close]').forEach(btn => {
      btn.addEventListener('click', () => {
        cartDrawer.classList.remove('is-open');
        document.body.style.overflow = '';
      });
    });

    const refreshDrawer = () => {
      return fetch('/?section_id=', { headers: { 'Accept': 'text/html' } })
        .then(() => fetch(window.location.pathname, { headers: { 'Accept': 'text/html' } }))
        .then(r => r.text())
        .then(html => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const fresh = doc.querySelector('[data-cart-drawer] [data-cart-drawer-panel]');
          const current = cartDrawer.querySelector('[data-cart-drawer-panel]');
          if (fresh && current) {
            current.innerHTML = fresh.innerHTML;
            cartDrawer.classList.toggle('has-items', doc.querySelector('[data-cart-drawer].has-items') !== null);
            if (typeof lucide !== 'undefined') lucide.createIcons();
            cartDrawer.querySelectorAll('[data-cart-close]').forEach(btn => {
              btn.addEventListener('click', () => {
                cartDrawer.classList.remove('is-open');
                document.body.style.overflow = '';
              });
            });
          }
          const badge = doc.querySelector('.cart-badge');
          const headerIcons = document.querySelector('.header__icons');
          const existingBadge = headerIcons?.querySelector('.cart-badge');
          if (existingBadge) existingBadge.remove();
          if (badge && headerIcons) {
            const cartBtn = headerIcons.querySelector('[data-cart-toggle]');
            if (cartBtn) cartBtn.insertAdjacentHTML('beforeend', badge.outerHTML);
          }
        });
    };

    const changeLine = (line, quantity) => {
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line, quantity })
      }).then(r => r.json()).then(refreshDrawer);
    };

    cartDrawer.addEventListener('click', (e) => {
      const minus = e.target.closest('[data-qty-minus]');
      const plus = e.target.closest('[data-qty-plus]');
      const remove = e.target.closest('[data-drawer-remove]');
      const item = e.target.closest('[data-drawer-item]');
      if (!item) return;
      const line = parseInt(item.getAttribute('data-line'), 10);
      const qtyEl = item.querySelector('[data-qty-value]');
      const current = parseInt(qtyEl?.textContent || '1', 10);
      if (minus) changeLine(line, Math.max(0, current - 1));
      else if (plus) changeLine(line, current + 1);
      else if (remove) changeLine(line, 0);
    });
  }

  // Card hover — auto-cycle images every 1s
  document.querySelectorAll('[data-card-hover]').forEach(card => {
    const imgs = card.querySelectorAll('.card__img');
    if (imgs.length < 2) return;
    let i = 0;
    let timer = null;
    const show = (n) => {
      imgs.forEach((el, k) => el.classList.toggle('is-active', k === n));
      i = n;
    };
    card.addEventListener('mouseenter', () => {
      clearInterval(timer);
      timer = setInterval(() => show((i + 1) % imgs.length), 1000);
    });
    card.addEventListener('mouseleave', () => {
      clearInterval(timer);
      show(0);
    });
  });

  // Product row arrows
  document.querySelectorAll('[data-row]').forEach(row => {
    const grid = row.querySelector('[data-row-grid]');
    const prev = row.querySelector('[data-row-prev]');
    const next = row.querySelector('[data-row-next]');
    if (!grid) return;
    const step = () => grid.clientWidth * 0.6;
    prev?.addEventListener('click', () => grid.scrollBy({ left: -step(), behavior: 'smooth' }));
    next?.addEventListener('click', () => grid.scrollBy({ left: step(), behavior: 'smooth' }));
  });

  // Reviews carousel (simple dot rotate)
  document.querySelectorAll('[data-reviews]').forEach(wrap => {
    const dots = wrap.querySelectorAll('[data-review-dot]');
    if (dots.length < 2) return;
    let i = 0;
    setInterval(() => {
      i = (i + 1) % dots.length;
      dots.forEach((d, n) => d.classList.toggle('is-active', n === i));
    }, 5000);
  });

  // Product page
  document.querySelectorAll('[data-product-page]').forEach(page => {
    const form = page.querySelector('.product-form');
    const variantScript = page.querySelector('[data-variants]');
    const variantInput = page.querySelector('[data-variant-id]');
    const priceEl = page.querySelector('[data-product-price]');
    const compareEl = page.querySelector('[data-product-compare]');
    const statusEl = page.querySelector('[data-product-status]');
    const addButton = page.querySelector('[data-add-to-cart]');
    const buyButton = page.querySelector('.product-page__buy');
    const notifyEl = page.querySelector('[data-notify]');
    const currencyCode = page.dataset.currencyCode || 'USD';
    const optionGroups = Array.from(page.querySelectorAll('[data-option-index]'));
    if (!form || !variantScript || !variantInput) return;

    let variants = [];
    try {
      variants = JSON.parse(variantScript.textContent || '[]');
    } catch (error) {
      variants = [];
    }
    if (!variants.length) return;

    const money = (amount) => {
      try {
        return new Intl.NumberFormat('en-IN', {
          style: 'currency',
          currency: currencyCode,
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }).format((amount || 0) / 100);
      } catch (error) {
        return ((amount || 0) / 100).toFixed(2);
      }
    };

    const getSelections = () => optionGroups.map(group => {
      const active = group.querySelector('.product-page__option-value.is-active');
      return active ? active.dataset.optionValue : '';
    });

    const updateVariant = () => {
      const selections = getSelections();
      const variant = variants.find(item => item.options.every((option, index) => option === selections[index]));
      if (!variant) {
        if (statusEl) statusEl.textContent = 'Please select a valid option combination';
        if (addButton) {
          addButton.disabled = true;
          addButton.textContent = 'Unavailable';
        }
        if (buyButton) buyButton.disabled = true;
        if (notifyEl) notifyEl.classList.add('is-hidden');
        return;
      }

      variantInput.value = variant.id;
      if (priceEl) priceEl.textContent = money(variant.price);
      if (compareEl) {
        const hasCompare = variant.compare_at_price && variant.compare_at_price > variant.price;
        compareEl.textContent = hasCompare ? money(variant.compare_at_price) : '';
        compareEl.classList.toggle('is-hidden', !hasCompare);
      }

      const available = Boolean(variant.available);
      if (statusEl) statusEl.textContent = available ? 'Ready to ship' : 'Currently unavailable';
      if (addButton) {
        addButton.disabled = !available;
        addButton.textContent = available ? 'Add to Cart' : 'Sold Out';
      }
      if (buyButton) buyButton.disabled = !available;
      if (notifyEl) notifyEl.classList.toggle('is-hidden', available);
    };

    optionGroups.forEach(group => {
      group.querySelectorAll('.product-page__option-value').forEach(button => {
        button.addEventListener('click', () => {
          group.querySelectorAll('.product-page__option-value').forEach(item => {
            item.classList.remove('is-active');
            item.setAttribute('aria-pressed', 'false');
          });
          button.classList.add('is-active');
          button.setAttribute('aria-pressed', 'true');
          updateVariant();
        });
      });
    });

    page.querySelectorAll('[data-qty]').forEach(wrap => {
      const minus = wrap.querySelector('[data-qty-minus]');
      const plus = wrap.querySelector('[data-qty-plus]');
      const input = wrap.querySelector('[data-qty-input]');
      if (!input) return;
      minus?.addEventListener('click', () => {
        input.value = Math.max(1, Number(input.value || 1) - 1);
      });
      plus?.addEventListener('click', () => {
        input.value = Math.max(1, Number(input.value || 1) + 1);
      });
    });

    page.querySelectorAll('[data-tabs]').forEach(tabs => {
      const buttons = tabs.querySelectorAll('[data-tab-target]');
      const panels = tabs.querySelectorAll('[data-tab-panel]');
      buttons.forEach(btn => {
        btn.addEventListener('click', () => {
          const target = btn.getAttribute('data-tab-target');
          buttons.forEach(b => {
            const active = b === btn;
            b.classList.toggle('is-active', active);
            b.setAttribute('aria-selected', active ? 'true' : 'false');
          });
          panels.forEach(panel => {
            const match = panel.getAttribute('data-tab-panel') === target;
            panel.classList.toggle('is-active', match);
            if (match) panel.removeAttribute('hidden');
            else panel.setAttribute('hidden', '');
          });
        });
      });
    });

    updateVariant();
  });

  // Product gallery carousel — manual nav buttons + dots
  document.querySelectorAll('[data-gallery]').forEach(gallery => {
    const track = gallery.querySelector('[data-gallery-track]');
    const slides = gallery.querySelectorAll('.product-page__media');
    const prev = gallery.querySelector('[data-gallery-prev]');
    const next = gallery.querySelector('[data-gallery-next]');
    const dots = gallery.querySelectorAll('[data-gallery-dot]');
    if (!track || slides.length < 2) return;
    let i = 0;
    const show = (idx) => {
      i = (idx + slides.length) % slides.length;
      track.style.transform = `translateX(-${i * 100}%)`;
      dots.forEach((d, n) => d.classList.toggle('is-active', n === i));
    };
    prev?.addEventListener('click', () => show(i - 1));
    next?.addEventListener('click', () => show(i + 1));
    dots.forEach((d, n) => d.addEventListener('click', () => show(n)));
    show(0);
  });

  // Cart page — quantity steppers, size change, live update
  document.querySelectorAll('[data-cart-page]').forEach(page => {
    const form = page.querySelector('.cart-page__form');
    if (!form) return;

    const postCartUpdate = (body) => {
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body),
      }).then(r => r.json());
    };

    const refreshCart = () => {
      fetch(window.location.pathname, { headers: { 'Accept': 'text/html' } })
        .then(r => r.text())
        .then(html => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const newSection = doc.querySelector('[data-cart-page]');
          if (newSection) {
            page.innerHTML = newSection.innerHTML;
            if (typeof lucide !== 'undefined') lucide.createIcons();
          }
        });
    };

    page.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-qty-minus], [data-qty-plus]');
      if (!btn) return;
      const item = btn.closest('[data-cart-item]');
      if (!item) return;
      const input = item.querySelector('[data-qty-input]');
      const current = parseInt(input.value || '1', 10);
      const next = btn.hasAttribute('data-qty-plus') ? current + 1 : Math.max(0, current - 1);
      input.value = next;
      const line = parseInt(item.getAttribute('data-line'), 10);
      postCartUpdate({ line, quantity: next }).then(refreshCart);
    });

    page.addEventListener('change', (e) => {
      const input = e.target.closest('[data-qty-input]');
      if (input) {
        const item = input.closest('[data-cart-item]');
        const line = parseInt(item.getAttribute('data-line'), 10);
        const next = Math.max(0, parseInt(input.value || '0', 10));
        postCartUpdate({ line, quantity: next }).then(refreshCart);
        return;
      }
      const sizeSelect = e.target.closest('[data-size-select]');
      if (sizeSelect) {
        const item = sizeSelect.closest('[data-cart-item]');
        const line = parseInt(item.getAttribute('data-line'), 10);
        const newVariantId = sizeSelect.value;
        const qty = parseInt(item.querySelector('[data-qty-input]').value || '1', 10);
        // remove current line, then add new variant
        postCartUpdate({ line, quantity: 0 })
          .then(() => fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ id: Number(newVariantId), quantity: qty }),
          }))
          .then(refreshCart);
      }
    });

    page.addEventListener('click', (e) => {
      const link = e.target.closest('.cart-item__remove');
      if (!link) return;
      e.preventDefault();
      const item = link.closest('[data-cart-item]');
      const line = parseInt(item.getAttribute('data-line'), 10);
      postCartUpdate({ line, quantity: 0 }).then(refreshCart);
    });
  });

  // Initialize Lucide icons
  if (typeof lucide !== 'undefined') lucide.createIcons();
})();
